import { jt, t } from 'ttag'
import React from 'react'
import { ReactBootstrapSlider } from 'react-bootstrap-slider'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import pagearrow from '@h2/assets/svg/icons/pageArrow.svg'

const RangeSlider = ({ id, data, min, max, ticks, formatFn, tooltip }) => {
  if (!data) {
    return null
  }

  const values = Array.isArray(data) && data.length == 1 ? [data[0], data[0]] : data
  //console.log(data, values, Array.isArray(values))
  const numTicks = 5
  const diff = Math.max(numTicks, 250000)
  const step = diff / numTicks - 1
  //console.log(diff, step)
  const newTicks = (ticks || []).map(t => t.value) //new Array(Math.min(numTicks, 250000)).fill().map( (_,c) => (c * step));
  const attrs = tooltip ? { tooltip } : {}

  //console.log(newTicks)
  if (newTicks.length > 0) {
    attrs.ticks = newTicks
  }
  /*
   *  console.log(newTicks)
   * const tickLabels = (ticks || []).map(t => t.label)
   */

  return (
    <div className="slider-holder">
      <ReactBootstrapSlider
        id={id || Math.random()}
        value={values}
        step={1}
        min={min}
        disabled={'disabled'}
        slideStop={() => {}}
        max={max}
        ticks={ticks}
        {...attrs}
      />
    </div>
  )
}

class LmiBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 0
    }
  }

  toCurrency(inp) {
    if (!inp) {
      return 'n/a'
    }

    return inp
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      .slice(0, -3)
  }

  outlookElement(ol, v, fmt) {
    if (ol && ol.hasOwnProperty(v)) {
      if (fmt) {
        return ol[v]?.toLocaleString()
      }

      return ol[v]
    }

    return fmt ? 'n/a' : null
  }

  getWageTicks() {
    const profile = this.props.profile

    if (!profile.wages) {
      return []
    }

    const wageArray = [{ label: '', value: 0 }]

    if (profile.wages.annual10) {
      wageArray.push({ label: '10% Annual', value: profile.wages.annual10 })
    }

    //if(profile.wages.annual25) wageArray.push({label: "25% Annual", value: profile.wages.annual25})
    if (profile.wages.annualMean) {
      wageArray.push({ label: 'Mean', value: profile.wages.annualMean })
    }

    //if(profile.wages.annual75) wageArray.push({label: "75% Annual", value: profile.wages.annual75})
    if (profile.wages.annual90) {
      wageArray.push({ label: '90% Annual', value: profile.wages.annual90 })
    }

    wageArray.push({ label: '', value: 250000 })

    return wageArray
  }

  getValues(ele) {
    const myArray = []
    const a10 = this.outlookElement(ele, 'annual10', false)

    if (a10) {
      myArray.push(a10)
    }

    const a90 = this.outlookElement(ele, 'annual90', false)
    const aMean = this.outlookElement(ele, 'annualMean', false)

    if (a90) {
      myArray.push(a90)
    } else if (aMean) {
      myArray.push(aMean)
    }

    return myArray.length > 0 ? myArray : null
  }

  getOutlookValues(ele) {
    const myArray = []
    const a10 = this.outlookElement(ele, 'baseEmployment', false)

    if (a10) {
      myArray.push(a10)
    }

    const a90 = this.outlookElement(ele, 'projectedEmployment', false)

    if (a90) {
      myArray.push(a90)
    }

    return myArray.length > 0 ? myArray : null
  }

  outlookClass(ele) {
    const projP = this.outlookElement(ele, 'projectedEmployment')
    const baseP = this.outlookElement(ele, 'baseEmployment')

    return projP - baseP > 0
      ? 'outlook-increasing'
      : projP - baseP < 0
      ? 'outlook-decreasing'
      : ''
  }

  wageComparisonBox() {
    const profile = this.props.profile
    const hasComparison = profile.comparisonWages && profile.comparisonWages.region
    const numCols = 12 / (hasComparison ? 2 : 1)
    const wageYear = this.outlookElement(profile.wages, 'year', false)
    const v2 = this.getValues(profile.wages)
    const minCurr = v2 && v2.length >= 1 ? this.toCurrency(v2[0]) : 'n/a'
    let maxCurr = this.outlookElement(profile.wages, 'annual90', false)

    maxCurr = maxCurr ? this.toCurrency(maxCurr) : '$208,000+'
    const v3 = this.getValues(profile.comparisonWages)
    const minCompCurr = v3 && v3.length >= 1 ? this.toCurrency(v3[0]) : 'n/a'
    let maxComCurr = this.outlookElement(profile.comparisonWages, 'annual90', false)

    maxComCurr = maxComCurr ? this.toCurrency(maxComCurr) : '$208,000+'
    //const maxComCurr =(v3 && v3.length >= 2) ? this.toCurrency(v3[1]) : "n/a"

    const avgSal = this.toCurrency(this.outlookElement(profile.wages, 'annualMean'))
    const avgCompSal = this.toCurrency(
      this.outlookElement(profile.comparisonWages, 'annualMean')
    )
    const region = this.outlookElement(profile.wages, 'region')
    const compRegion = this.outlookElement(profile.comparisonWages, 'region')
    const boldWage = <b>{avgSal}</b>
    const boldCompWage = <b>{avgCompSal}</b>

    return (
      <div>
        <h4>
          {t`Earnings`}{' '}
          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            onClick={this.props.openRegionsModal}
            className="pull-right lmi-location">
            <i className="fal fa-map-marker" aria-hidden="true"></i>
            {this.outlookElement(profile.wages, 'region')}
            {hasComparison ? (
              <span className="comparison-region">
                {' '}
                / {this.outlookElement(profile.comparisonWages, 'region')}
              </span>
            ) : null}
          </button>
        </h4>
        <div className="row">
          <div className={`col-xs-${numCols}`}>
            <RangeSlider
              data={this.getValues(profile.wages)}
              id="wage-1"
              tooltip="hide"
              ticks={this.getWageTicks()}
              min={0}
              max={210000}
            />
            <div className="clear-fix">
              <h5>{t`${minCurr} to ${maxCurr}`}</h5>
            </div>
            <p
              style={{
                color: 'black'
              }}>
              {jt`with an average salary in ${region} of ${boldWage}`}
            </p>
          </div>

          {hasComparison && (
            <div className={`col-xs-${numCols}`}>
              <RangeSlider
                data={this.getValues(profile.comparisonWages)}
                tooltip="hide"
                id="comp-wage-1"
                ticks={this.getWageTicks()}
                min={0}
                max={210000}
              />
              <h5>
                <span className="comparison-region">{t`${minCompCurr} to ${maxComCurr}`}</span>
              </h5>
              <p
                style={{
                  color: 'black'
                }}>
                {jt`with an average salary in ${compRegion} of ${boldCompWage}`}
              </p>
            </div>
          )}
        </div>
      </div>
    )
  }

  outlookComparisonBox() {
    const profile = this.props.profile
    const hasComparison = profile.comparisonOutlook && profile.comparisonOutlook.region
    const numCols = 12 / (hasComparison ? 2 : 1)
    const regionName = this.outlookElement(profile.wages, 'region')
    const annualTotal = this.outlookElement(profile.outlook, 'annualTotal', true)
    const annualTurnover = this.outlookElement(profile.outlook, 'annualTurnover', true)
    const annualOpenings = this.outlookElement(profile.outlook, 'annualOpenings', true)
    const projectedEmploymentYear = this.outlookElement(
      profile.outlook,
      'projectedEmploymentYear',
      false
    )
    const projectedEmployment = this.outlookElement(
      profile.outlook,
      'projectedEmployment',
      true
    )
    const currentEmployment = this.outlookElement(profile.outlook, 'baseEmployment', true)
    const comparisonAnnualTotal = this.outlookElement(
      profile.comparisonOutlook,
      'annualTotal',
      true
    )
    const comparisonAnnualTurnover = this.outlookElement(
      profile.comparisonOutlook,
      'annualTurnover',
      true
    )
    const comparisonAnnualOpenings = this.outlookElement(
      profile.comparisonOutlook,
      'annualOpenings',
      true
    )
    const comparisonProjectedEmploymentYear = this.outlookElement(
      profile.comparisonOutlook,
      'projectedEmploymentYear',
      false
    )
    const comparisonProjectedEmployment = this.outlookElement(
      profile.comparisonOutlook,
      'projectedEmployment',
      true
    )
    const comparisonCurrentEmployment = this.outlookElement(
      profile.comparisonOutlook,
      'baseEmployment',
      true
    )
    const yr = this.outlookElement(profile.outlook, 'baseEmploymentYear', false)
    const compYr = this.outlookElement(
      profile.comparisonOutlook,
      'baseEmploymentYear',
      false
    )
    const currentEmploymentBold = <b>{currentEmployment}</b>
    const projectedEmploymentBold = <b>{projectedEmployment}</b>
    const annualTotalBold = <b>{annualTotal}</b>
    const annualTurnoverBold = <b>{annualTurnover}</b>
    const comparisonCurrentEmploymentBold = <b>{comparisonCurrentEmployment}</b>
    const comparisonProjectedEmploymentBold = <b>{comparisonProjectedEmployment}</b>
    const comparisonAnnualTotalBold = <b>{comparisonAnnualTotal}</b>
    const comparisonAnnualTurnoverBold = <b>{comparisonAnnualTurnover}</b>

    return (
      <div>
        <h4>
          {t`Employment`}{' '}
          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            onClick={this.props.openRegionsModal}
            className="pull-right lmi-location">
            <i className="fal fa-map-marker" aria-hidden="true"></i>
            {regionName}
            {hasComparison ? (
              <span className="comparison-region">
                {' '}
                / {this.outlookElement(profile.comparisonOutlook, 'region')}
              </span>
            ) : null}
          </button>
        </h4>
        <div className="row">
          <div className={`col-xs-${numCols} ${this.outlookClass(profile.outlook)}`}>
            {profile.outlook && (
              <RangeSlider
                data={[10, 90]}
                id="outlook-1"
                ticks={[
                  { label: '', value: 10 },
                  { label: '', value: 50 },
                  { label: '', value: 90 }
                ]}
                tooltip="hide"
                min={0}
                max={100}
              />
            )}
            {profile.outlook && (
              <h5>
                {currentEmployment}{' '}
                <span className="arrow-indicator">
                  <i className="fas fa-chevron-circle-right"></i>
                </span>
                {projectedEmployment}
              </h5>
            )}
            {!profile.outlook && <h5>{t`not available`}</h5>}
            <div className="description-box">
              {profile.outlook && (
                <p
                  style={{
                    color: 'black'
                  }}>
                  {jt`In ${yr}, approximately ${currentEmploymentBold} people were employed in ${profile.outlook.region} increasing to ${projectedEmploymentBold} by ${projectedEmploymentYear}. During that time, ${annualTotalBold} openings are projected each year with ${annualTurnoverBold} due to turnover.`}
                </p>
              )}
              {!profile.outlook && (
                <p
                  style={{
                    color: 'black'
                  }}>
                  {jt`Projection information not available for ${regionName}`}
                </p>
              )}
            </div>
          </div>

          {hasComparison && (
            <div
              className={`col-xs-${numCols} ${this.outlookClass(
                profile.comparisonOutlook
              )}`}>
              {profile.comparisonOutlook && (
                <RangeSlider
                  data={[10, 90]}
                  id="comp-outlook-1"
                  ticks={[
                    { label: '', value: 10 },
                    { label: '', value: 50 },
                    { label: '', value: 90 }
                  ]}
                  tooltip="hide"
                  min={0}
                  max={100}
                />
              )}
              {profile.comparisonOutlook && (
                <h5>
                  <span className="comparison-region">
                    {comparisonCurrentEmployment}
                    <span className="arrow-indicator">
                      <i className="fas fa-chevron-circle-right"></i>
                    </span>
                    {comparisonProjectedEmployment}{' '}
                  </span>
                </h5>
              )}
              {!profile.comparisonOutlook && <h5>{t`not available`}</h5>}
              <div className="description-box">
                {!profile.comparisonOutlook && (
                  <p style={{ color: 'black' }}>
                    <span className="comparison-region">{jt`Projection information not available for this region`}</span>
                  </p>
                )}
                {profile.comparisonOutlook && (
                  <p style={{ color: 'black' }}>
                    <span className="comparison-region">{jt`In ${compYr}, approximately ${comparisonCurrentEmploymentBold} people were employed in ${profile.comparisonOutlook.region} increasing to ${comparisonProjectedEmploymentBold} by ${comparisonProjectedEmploymentYear}. During that time, ${comparisonAnnualTotalBold} openings are projected each year with ${comparisonAnnualTurnoverBold} due to turnover.`}</span>
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }

  initialLmiBox() {
    const profile = this.props.profile
    const hasComparison = profile.comparisonWages && profile.comparisonWages.region

    return (
      <div>
        <h4>
          {t`Average Salary`}{' '}
          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            onClick={this.props.openRegionsModal}
            className="pull-right lmi-location">
            <i className="fal fa-map-marker" aria-hidden="true"></i>
            {this.outlookElement(profile.wages, 'region')}
            {hasComparison ? (
              <span className="comparison-region">
                {' '}
                / {this.outlookElement(profile.comparisonWages, 'region')}
              </span>
            ) : null}
          </button>
        </h4>
        <RangeSlider
          data={this.getValues(profile.wages)}
          tooltip="hide"
          id="wage-2"
          ticks={this.getWageTicks()}
          min={0}
          max={210000}
        />
        <div style={{ height: '55px' }}>
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="right"
            overlay={(
              <Popover title={t`Wage Info`} id="wagepopover">
                {(() => {
                  const v2 = this.getValues(profile.wages)

                  if (v2) {
                    const minCurr = v2.length >= 1 ? this.toCurrency(v2[0]) : 'n/a'
                    let maxCurr = v2.length >= 2 ? this.toCurrency(v2[1]) : 'n/a'
                    const avg = this.toCurrency(
                      this.outlookElement(profile.wages, 'annualMean', false)
                    )
                    const yr = this.outlookElement(profile.wages, 'year', false)

                    if (avg === maxCurr) {
                      maxCurr += '+'
                    }

                    return t`In ${yr}, the average annual wage in ${profile.wages.region} was ${avg} with most workers making between ${minCurr} and ${maxCurr}`
                  }
                })()}
              </Popover>
            )}>
            <button
              style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
              onClick={() => this.setState({ ...this.state, page: 1 })}>
              <h5 className="defined" style={{ color: 'black' }}>
                {this.toCurrency(this.outlookElement(profile.wages, 'annualMean'))}{' '}
                {hasComparison ? (
                  <span className="comparison-region">
                    /{' '}
                    {this.toCurrency(
                      this.outlookElement(profile.comparisonWages, 'annualMean')
                    )}
                  </span>
                ) : null}
              </h5>
            </button>
          </OverlayTrigger>
          <br className="clear" />
        </div>

        <div className="row">
          <div className={`col-xs-6  ${this.outlookClass(profile.outlook)}`}>
            <h4 className="clear">{t`Annual Openings`}</h4>
            <RangeSlider
              data={[10, 90]}
              tooltip="hide"
              id="outlook-2"
              min={0}
              max={100}
            />
            <div style={{ height: '55px' }}>
              <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="right"
                overlay={(
                  <Popover title={t`Projection Info`} id="projectionpopover">
                    {(() => {
                      const v2 = this.getValues()
                      const annualTotal = this.outlookElement(
                        profile.outlook,
                        'annualTotal',
                        true
                      )
                      const annualTurnover = this.outlookElement(
                        profile.outlook,
                        'annualTurnover',
                        true
                      )
                      const annualOpenings = this.outlookElement(
                        profile.outlook,
                        'annualOpenings',
                        true
                      )
                      const projectedEmploymentYear = this.outlookElement(
                        profile.outlook,
                        'projectedEmploymentYear',
                        false
                      )
                      const projectedEmployment = this.outlookElement(
                        profile.outlook,
                        'projectedEmployment',
                        true
                      )
                      const currentEmployment = this.outlookElement(
                        profile.outlook,
                        'baseEmployment',
                        true
                      )
                      const yr = this.outlookElement(
                        profile.outlook,
                        'baseEmploymentYear',
                        false
                      )

                      if (profile.outlook) {
                        return (
                          <div>
                            <p>{t`During ${yr}, this occupation employed approximately ${currentEmployment} people in ${profile.outlook.region}. It is projected that there will be ${projectedEmployment} employed in ${projectedEmploymentYear}.`}</p>
                            <p>{t`This occupation will have about ${annualOpenings} openings due to growth and about ${annualTurnover} replacement openings for approximately ${annualTotal} total annual openings.`}</p>
                          </div>
                        )
                      }
                    })()}
                  </Popover>
                )}>
                <button
                  style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
                  onClick={() => this.setState({ ...this.state, page: 2 })}>
                  <h5 className="defined" style={{ color: 'black' }}>
                    {this.outlookElement(profile.outlook, 'annualTotal', true)}{' '}
                    {hasComparison ? (
                      <span className="comparison-region">
                        / {this.outlookElement(profile.comparisonOutlook, 'annualTotal')}
                      </span>
                    ) : null}
                  </h5>
                </button>
              </OverlayTrigger>
            </div>
          </div>
          <div className="col-xs-5 col-xs-offset-1">
            <h4 className="clear">{t`Preparation`}</h4>
            <RangeSlider
              data={[
                profile.jobZone ? profile.jobZone.id : 0,
                profile.jobZone ? profile.jobZone.id : 0
              ]}
              formatFn={v => {
                return profile.jobZone ? profile.jobZone.name : t`Not specified`
              }}
              id="jz-2"
              tooltip="hide"
              ticks={[
                { value: 1 },
                { value: 2 },
                { value: 3 },
                { value: 4 },
                { value: 5 }
              ]}
              min={1}
              max={5}
            />
            <div style={{ height: '55px' }}>
              <OverlayTrigger
                trigger={['hover', 'focus']}
                placement="top"
                overlay={(
                  <Popover
                    title={profile.jobZone ? profile.jobZone.name : t`Not specified`}
                    id="jobzonepopover">
                    {profile.jobZone ? profile.jobZone.education : ''}
                  </Popover>
                )}>
                <h5 className="defined">
                  <span className="smaller">{t`Job Zone`}</span>
                  &#160;{profile.jobZone ? profile.jobZone.id : t`n/a`}
                </h5>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
    )
  }

  innerContent() {
    switch (this.state.page) {
      case 1:
        return this.wageComparisonBox()
      case 2:
        return this.outlookComparisonBox()
      default:
        return this.initialLmiBox()
    }
  }

  render() {
    const maxPage = 2
    const currPage = this.state.page
    const hasNext = maxPage > currPage
    const hasPrev = currPage > 0
    const whichClass = p => {
      return p === currPage ? 'fas fa-circle' : 'fal fa-circle'
    }

    return (
      <div>
        <div className="lmi-content">{this.innerContent()}</div>
        <div className="lmi-nav">
          <a
            disabled={!hasPrev}
            onClick={() => {
              if (hasPrev) {
                this.setState({ ...this.state, page: currPage - 1 })
              }
            }}>
            <img
              src={pagearrow}
              className={`nav-selector ${hasPrev ? '' : 'disabled'}`}
              alt={t`Left arrow to move page to previous section`}
              style={{
                transform: 'rotate(180deg)'
              }}
            />
          </a>
          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            onClick={() => this.setState({ ...this.state, page: 0 })}>
            <i className={whichClass(0)} aria-hidden="true"></i>
            <span className={'sr-only'}>{t`Slide ${1} of 3`}</span>
          </button>

          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            onClick={() => this.setState({ ...this.state, page: 1 })}>
            <i className={whichClass(1)} aria-hidden="true"></i>
            <span className={'sr-only'}>{t`Slide ${2} of 3`}</span>
          </button>
          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            onClick={() => this.setState({ ...this.state, page: 2 })}>
            <i className={whichClass(2)} aria-hidden="true"></i>
            <span className={'sr-only'}>{t`Slide ${3} of 3`}</span>
          </button>

          <button
            style={{ border: 0, padding: '2px', backgroundColor: 'transparent' }}
            disabled={!hasNext}
            onClick={() => {
              if (hasNext) {
                this.setState({ ...this.state, page: currPage + 1 })
              }
            }}>
            <img
              src={pagearrow}
              alt={t`Right arrow to move page to next section`}
              className={`nav-selector ${hasNext ? '' : 'disabled'}`}
            />
          </button>
        </div>
      </div>
    )
  }
}

export default LmiBox
